
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_1hnrt_9",
  "disabled": "awsui_disabled_16mm3_1hnrt_25",
  "no-content-styling": "awsui_no-content-styling_16mm3_1hnrt_29",
  "expandable-header": "awsui_expandable-header_16mm3_1hnrt_35",
  "rolled-down": "awsui_rolled-down_16mm3_1hnrt_46",
  "highlighted": "awsui_highlighted_16mm3_1hnrt_49",
  "is-focused": "awsui_is-focused_16mm3_1hnrt_72",
  "visual-refresh": "awsui_visual-refresh_16mm3_1hnrt_75",
  "category": "awsui_category_16mm3_1hnrt_79",
  "expandable": "awsui_expandable_16mm3_1hnrt_35",
  "variant-navigation": "awsui_variant-navigation_16mm3_1hnrt_94",
  "expand-icon": "awsui_expand-icon_16mm3_1hnrt_101",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_1hnrt_119",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_1hnrt_122",
  "items-list-container": "awsui_items-list-container_16mm3_1hnrt_130",
  "in-dropdown": "awsui_in-dropdown_16mm3_1hnrt_139",
  "icon-wrapper": "awsui_icon-wrapper_16mm3_1hnrt_143",
  "header-content": "awsui_header-content_16mm3_1hnrt_147"
};
  